<template>
  <div class="text-xs-center">
    <v-dialog
      :value="value"
      @input="$emit('input')"
      width="500"
    >
      <v-card>
        <v-card-title
          class="headline grey lighten-2 py-2"
          primary-title
        >
          Duplicar Atividade
          <v-spacer></v-spacer>
          <v-tooltip bottom>
            <v-btn
              flat
              fab
              small
              icon
              @click="$emit('input')"
              slot="activator"
            >
              <v-icon>close</v-icon>
            </v-btn>
            <span>Cancelar</span>
          </v-tooltip>
          <v-tooltip bottom>
            <v-btn
              color="primary"
              fab
              dark
              small
              @click="adiciona"
              :loading="loading"
              slot="activator"
            >
              <v-icon>done</v-icon>
            </v-btn>
            <span>Salvar</span>
          </v-tooltip>
        </v-card-title>

        <v-card-text>
          <v-alert
            :value="true"
            type="warning"
          >
            <span class="subheading font-weight-bold">Você está prestes à duplicar: <span v-if="!atividade">{{ atividadesSelected.length }} {{ atividadesSelected.length > 1 ? 'atividades' : 'atividade' }}</span></span>
          </v-alert>
          <v-card v-if="atividade" class="mt-3">
            <v-card-title primary-title class="pa-2">
              <v-flex xs12>
                <div class="subheading font-weight-medium">{{ atividade.Descricao }}</div>
                <v-divider class="my-1"></v-divider>
                <div>
                  <v-icon small>event</v-icon> {{ moment(atividade.DataPrevisao).format('DD [de] MMMM [de] YYYY') }}
                </div>
                <div><v-icon small>person</v-icon> {{ atividade.Responsavel }}</div>
                <div><v-chip label dark small :color="atividade.Cor">{{ atividade.Situacao }}</v-chip></div>
              </v-flex>
            </v-card-title>
          </v-card>
          <v-text-field v-model="descricaoAtividade" hide-details label="Descrição Atividade" class="mt-3"></v-text-field>
          <v-checkbox v-model="duplicar" hide-details color="primary" value="checklists" label="CHECKLISTS"></v-checkbox>
          <v-checkbox v-model="duplicar" hide-details color="primary" value="tags" label="TAGS"></v-checkbox>
          <v-checkbox v-model="duplicar" hide-details color="primary" value="colaboradores" label="COLABORADORES"></v-checkbox>
          <v-checkbox v-model="duplicar" hide-details color="primary" value="clientes" label="CLIENTES"></v-checkbox>
          <v-checkbox v-model="duplicar" hide-details color="primary" value="datas" label="SETAR DATA ATUAL"></v-checkbox>
        </v-card-text>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import { mapGetters, mapActions, mapMutations } from 'vuex';
export default {
  props: ['value', 'atividade', 'loading'],
  data() {
    return {
      descricao: '',
      duplicar: []
    }
  },
  methods: {
    ...mapMutations(['showNotification', 'closeNotification']),
    adiciona() {
      if (this.atividade !== null) {
        const objDuplicar = {
          atividades: [this.atividade.IdAtividade],
          descricao: this.descricao,
          itens: this.duplicar
        }
        this.$emit('duplicaAtividade', objDuplicar);
        this.duplicar = [];
      } else {
        const objDuplicar = {
          atividades: this.atividadesSelected.map(atividade => atividade.IdAtividade),
          descricao: this.descricao,
          itens: this.duplicar
        }
        this.$emit('duplicaAtividade', objDuplicar);
        this.duplicar = [];
      }
    }
  },
  computed: {
    ...mapGetters(['atividadesSelected']),
    descricaoAtividade: {
      // getter
      get: function () {
        if (this.atividade) {
          this.descricao = this.atividade.Descricao;
          return this.atividade.Descricao;
        } else if (this.atividadesSelected.length === 1) {
          this.descricao = this.atividadesSelected[0].Descricao;
          return this.atividadesSelected[0].Descricao;
        } else {
          return '';
        }
      },
      set: function (value) {
        this.descricao = value;
      }
    }
  },
}
</script>

<style>

</style>
